import { render, staticRenderFns } from "./VerifyOTP.vue?vue&type=template&id=d3ec6b3a&scoped=true"
import script from "./VerifyOTP.vue?vue&type=script&lang=js"
export * from "./VerifyOTP.vue?vue&type=script&lang=js"
import style0 from "./VerifyOTP.vue?vue&type=style&index=0&id=d3ec6b3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3ec6b3a",
  null
  
)

export default component.exports